import { useMemo } from 'react';
import { useTranslation as _useTranslation } from 'react-i18next';
import _ from 'lodash';
import T, { LOCALIZATION_PREFIX } from './LocalizationKeys';


class Validator {
  constructor(t) {
    this.t = t;
  }

  localize = (key) => {
    // If key starts with LOCALIZATION_PREFIX then it's a real translation key, else use key as value
    if (_.startsWith(key, LOCALIZATION_PREFIX)) {
      const keyValue = _.get(T, _.trimStart(key, LOCALIZATION_PREFIX));
      return this.t(_.trimStart(keyValue, LOCALIZATION_PREFIX));
    }
    // Key is the value
    return key;

  };

  get = (target, key) => {
    if (key === 'localize') {
      return this.localize;
    }
    if (_.isObject(target[key])) {
      return new Proxy(target[key], new Validator(this.t));
    }
    const keyValue = _.get(target, key);
    return this.t(_.trimStart(keyValue, LOCALIZATION_PREFIX));
  };
}

export const useTranslation = () => {
  const { t } = _useTranslation();
  return useMemo(() => {
    const value = new Proxy(T, new Validator(t));
    // this keeps eslint quiet in other parts of the code
    value.localize = (...args) => value.localize(...args);
    return value;
  }, [t]);
};
